import React from 'react';

export default class Footer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <footer>
                <div className="container">
                    <div className="row footer-widgets">
                        <div className="col-md-3">
                            <div className="footer-widget contact-widget">
                                <h4>
                                    Contact:<span className="head-line"></span>
                                </h4>
                                <ul>
                                    <li>
                                        <span>Adresse:</span> 4 rue de
                                        l’herminette – 85300 SALLERTAINE
                                    </li>
                                    <li>
                                        <span>Téléphone:</span> +33 (0)2 85 29
                                        24 24
                                    </li>
                                    <li>
                                        <span>E-mail:</span>{' '}
                                        contact@stapmedif.fr
                                    </li>
                                    <li>
                                        <span>Site web:</span> www.stapmedif.fr
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="footer-widget">
                                <h4>
                                    Nos prestations
                                    <span className="head-line"></span>
                                </h4>
                                <ul>
                                    <li>
                                        Réception téléphonique, Prise de
                                        rendez-vous et frappe de comptes-rendus
                                    </li>
                                    <li>
                                        <b>STAP-Doc'sécur</b> : Partage sécurisé
                                        de documents digitalisés dans le respect
                                        du RGPD
                                    </li>
                                    <li>
                                        <b>STAP-Guid’appels</b> : Aide à la
                                        conduite de conversation pour prise de
                                        rendez-vous médicaux
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="footer-widget twitter-widget">
                                <h4>
                                    Nos points forts{' '}
                                    <span className="head-line"></span>
                                </h4>
                                <ul>
                                    <li>Service 100% français, 100% local</li>
                                    <li>
                                        Pas de sous-traitance ni
                                        d’externalisation
                                    </li>
                                    <li>Accueil professionnel et souriant</li>
                                    <li>
                                        Terminologie de votre spécialité
                                        maitrisée
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="footer-widget social-widget">
                                <h4>
                                    Suivez-nous
                                    <span className="head-line"></span>
                                </h4>
                                <ul className="social-icons">
                                    <li>
                                        <a
                                            className="linkdin"
                                            target="_blank"
                                            href="https://www.linkedin.com/in/stapmedif-op%C3%A9rateur-de-service-pour-professionnels-de-sant%C3%A9/"
                                        >
                                            <i className="icon-linkedin-1"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="twitter"
                                            target="_blank"
                                            href="https://twitter.com/stapmedif"
                                        >
                                            <i className="icon-twitter-2"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="facebook"
                                            target="_blank"
                                            href="https://www.facebook.com/Stapmedif-355924515306119/"
                                        >
                                            <i className="icon-facebook-2"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="copyright-section">
                        <div className="row">
                            <div className="col-md-6">
                                <p>© 2021 Corteks - All Rights Reserved</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer.jsx